import _ from 'underscore';
import React, { Children, cloneElement, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Layer } from '@bingads-webui-react/fabric-control';

import { Button, makeStyles, mergeClasses } from '@fluentui/react-components';
import {
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  DrawerFooter,
  OverlayDrawer,
} from '@fluentui/react-drawer';
import { Dismiss24Regular } from '@fluentui/react-icons';

const TOP_BANNER_HEIGHT = 60;

const useStyles = makeStyles({
  addMediaPanel: {
    height: `calc(100vh - ${TOP_BANNER_HEIGHT}px)`,
    top: 'auto',
    bottom: '0px',
  },
  panelContent: {
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
  },
  overlay: {
    zIndex: '2',
  },
  layer: {
    zIndex: '1000',
  },
});

export const AdsStudioPanelContainer = forwardRef((props, ref) => {
  const {
    onRenderFooterContent,
    isOpen,
    dismiss,
    headerText,
    children,
    size,
    className,
  } = props;

  const overlayBodyRef = useRef(null);
  const styles = useStyles();

  return (
    <>
      <OverlayDrawer
        ref={ref}
        open={isOpen}
        modalType="non-modal"
        position="end"
        size={size}
        tabIndex={0}
        className={mergeClasses(styles.addMediaPanel, 'ads-studio-panel-container-drawer-overlay', className)}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <Button
                className="panel-close-button"
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={dismiss}
              />
            }
          >
            {headerText}
          </DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody ref={overlayBodyRef} className={mergeClasses(styles.addMediaPanel, 'ads-studio-panel-container-drawer-overlay-body')}>
          {Children.map(children, child =>
            child && cloneElement(child, {
              overlayBodyRef,
            }))}
        </DrawerBody>
        <DrawerFooter>
          {onRenderFooterContent}
        </DrawerFooter>
      </OverlayDrawer>
      {
        isOpen && (
          <Layer className={mergeClasses('panel-layer', styles.layer)}>
            <Overlay isDarkThemed className={styles.overlay} />
          </Layer>
        )
      }
    </>
  );
});

AdsStudioPanelContainer.propTypes = {
  onRenderFooterContent: PropTypes.func,
  isOpen: PropTypes.bool,
  dismiss: PropTypes.func,
  headerText: PropTypes.string,
  children: PropTypes.element,
  size: PropTypes.string,
  className: PropTypes.string,
};

AdsStudioPanelContainer.defaultProps = {
  onRenderFooterContent: _.noop,
  isOpen: false,
  dismiss: _.noop,
  headerText: '',
  children: null,
  size: 'large',
  className: '',
};

